/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getPageCount__anchor
 */
export default () => window.documentViewer.getPageCount();
